// The archival endpoint answers `204`, no body: `archivedAt` is the local instant captured at the
// call site, not a value echoed by the server.
export type DocumentTypeArchivedPayload = {
	documentTypeId: number;
	archivedAt: string;
};

export type DocumentTypeArchivedAction = {
	type: 'DOCUMENT_TYPE_ARCHIVED';
	payload: DocumentTypeArchivedPayload;
	accountId: number;
};

export default (payload: DocumentTypeArchivedPayload, accountId: number): DocumentTypeArchivedAction => ({
	type: 'DOCUMENT_TYPE_ARCHIVED',
	payload,
	accountId,
});
